import './styles/brand.css';
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { initPostHog } from './providers/PostHogProvider';
import { initSentry } from './providers/SentryProvider';
import { getConsentState, loadGoogleAnalytics } from './lib/analytics';

// Sentry captures errors regardless of cookie consent — it processes no personal data
initSentry();

// Analytics (PostHog + GA) only run when the user has previously accepted cookies.
// If consent is not yet recorded the CookieBanner component handles first-time init.
if (getConsentState() === 'accepted') {
  initPostHog();
  loadGoogleAnalytics();
}

console.log("SideoutIQ: Entry point index.tsx reached.");

// Signal to the health check that JS execution has started
// @ts-ignore
window.VP_MOUNTED = true;

const container = document.getElementById('root');

if (container) {
  try {
    const root = createRoot(container);
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
    
    console.log("SideoutIQ: React v18 render sequence initiated.");
  } catch (error) {
    console.error("SideoutIQ: Mount failure during React initialization:", error);
    throw error;
  }
} else {
  console.error("SideoutIQ: #root element missing in DOM.");
}